// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipWrapper":"x8J2i","displayArrow":"eBp5y","enableOverlay":"Xg1ZB","top":"_5W3CU","overlayDesign":"b-ors","tooltipContent":"UXkT2","visible":"GTyqV"};